import { IgetUnidadesDropDownUseCase } from "../../../presentation/useCases/read/get_unidades_drop_down_use_case";
import { DropDown } from "../../models/dropdown";
import { DropDownUnidade } from "../../models/dropdownUnidade";
import { ICommonsRepository } from "../../repositories/commons_repository";

/**
 * getUnidadesDropDownUseCase
 */

export class getUnidadesDropDownUseCase implements IgetUnidadesDropDownUseCase {
  constructor(private readonly repository: ICommonsRepository) { }

  async getUnidadesDropDown(): Promise<DropDownUnidade[]> {
    return this.repository.getUnidadesDropDown();
  }

}
